export default class LeanLawAuth {
  login() {
    const loginUrl = `${this.domain}/account/login/?redirect=${this.myLocation()}`;
    window.location.href = loginUrl;
  }

  // Ignores arguments: HeaderComponent passes a 'header' label that must never become the redirect.
  logoff() {
    this.logoffTo(this.myLocation());
  }
  logoffTo(encodedRedirect) {
    const logoffUrl = `${this.domain}/account/logoff?redirect=${encodedRedirect}`;
    window.location.href = logoffUrl;
  }
  myLocation() {
    const self = window.location.href.split('#')[0];
    return encodeURIComponent(self.replace(/\/$/, ''));
  }
  get domain() {
    const domain = LEANLAW_API || '';
    window.leanlaw.domain = domain;
    return domain;
  }
  get source() {
    const source = 'myleanlaw';
    window.leanlaw.source = source;
    return source;
  }
  get features() {
    window.leanlaw.features = {};
    return {};
  }
}